/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ils } from '../../models/ils';

export interface IlsPublishingControllerUnpublishIls$Params {
  ilsId: string;
}

export function ilsPublishingControllerUnpublishIls(http: HttpClient, rootUrl: string, params: IlsPublishingControllerUnpublishIls$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
  const rb = new RequestBuilder(rootUrl, ilsPublishingControllerUnpublishIls.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ils>;
    })
  );
}

ilsPublishingControllerUnpublishIls.PATH = '/ils-publishing/{ilsId}/unpublishIls';
